export function appDataReducerLogin(state, action) {
    return action;
}
